<template>
    <div class="fixed w-full h-full left-0 top-0 z-[2000] flex flex-col overflow-hidden">
        <div class="absolute left-0 top-0 h-full w-full bg-black bg-opacity-50" />
        <div class="absolute z-10 bg-white shadow-lg w-[600px] bottom-auto rounded-3xl left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
            <button class="th-btn th-btn-plain th-btn-only-icon absolute right-4 top-4" @click="onClose">
                <PtIcon class="th-btn-icon text-2xl" icon="SolidCloseBig" />
            </button>
            <div class="flex flex-col p-4 md:px-12 md:py-10 items-center">
                <PtIcon class="shrink-0 !w-[190px] !h-[114px] mb-10" :icon="LogoAmountDown" />
                <h2 class="text-2xl font-semibold text-black mb-4 max-w-[520px] text-center">
                    {{ t('duplicatePermissionDialog.title') }}
                </h2>
                <p class="text-sm text-black mb-10">
                    {{ t('duplicatePermissionDialog.desc') }}
                </p>

                <a class="th-btn th-btn-text" href="/">
                    {{ t('duplicatePermissionDialog.upgradeButton') }}
                </a>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { PtIcon } from 'patsnap-biz';
// @ts-ignore
import LogoAmountDown from '../../assets/icon/amount-down.svg';
import '@patsnap-ui/icon/assets/solid/CloseBig.svg'

const props = defineProps<{
    callback: () => void;
}>();

const { t } = useI18n();

function onClose() {
    props.callback();
}
</script>
